<template>
  <v-dialog
      v-model="dialog"
      max-width="600"
  >
    <v-card>
      <v-card-title>Duyurular</v-card-title>
      <v-card-text>
        <div v-if="announcementList">
          <v-expansion-panels>
            <v-expansion-panel
                v-for="i in announcementList"
                :key="i.id"
            >
              <v-expansion-panel-header
              >
                <h5 class="mb-0">{{ i.subject }}</h5>
                <h5 class="text-danger text-right mr-2 mb-0">{{ "Yayımlanma Tarihi: " + formattedDate(i.startDate) }}</h5>
              </v-expansion-panel-header>
              <v-expansion-panel-content>{{ i.body }}</v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div v-else>
          <h6>Henüz bir duyurunuz bulunmamaktadır</h6>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="red darken-2" @click="dialog = false">Kapat</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>
<script>

import {mapActions, mapState} from "vuex";
import {formattedDate} from "@/momentHelper";

export default {
  name: "AnnouncementDialog",
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState("announcement", ["announcementList"]),
    ...mapState("auth", ["user"]),
  },
  created() {
    this.fetchAnnouncementList({
      params: {
        userId: this.user.UserId
      },
      body: {},

    });
  },
  data() {
    return {
      userBranchCodeVal: null,
      userWarehouseCodeVal: null,
      dialog: false
    }
  },
  methods: {
    ...mapActions("announcement", ["fetchAnnouncementList"]),
    ...mapActions("auth", ["getLoggedUser"]),
    ...mapActions("user", ["userBranchWarehouseUpdate"]),
    formattedDate,
  },
  watch: {
    "dialog": function (newVal) {
      this.$emit("dialogChange", newVal);
    },
    showDialog: function (newVal) {
      this.dialog = newVal;
    }
  }
}
</script>

<style scoped>

</style>